<template>
    <div>
        <div class="indexcon">
            <div class="banner-box">
                <!-- Element 轮播组件 -->
                <!-- :height="bannerHeight" -->
                <el-carousel :height="carouselH + 'vw'" :autoplay="autoPlay" :interval="5000" arrow="hover"
                    indicator-position="inside">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <!-- 图片类型：点击跳转 -->
                        <div v-if="item.is_type == 1" class="banner-item" @click="goLink(item.pc_url)">
                            <img :src="$img(item.pc_image)" alt="" />
                        </div>

                        <!-- 视频类型：点击打开弹窗播放 -->
                        <div v-else class="banner-item"
                            @click="openVideoDialog(item.video)">
                            <!-- 视频封面图 -->
                            <img :src="$img(item.pc_image)" alt="" />
                            <!-- 播放图标遮罩 -->
                            <div class="play-mask">
                                <i class="el-icon-video-play"></i>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <!-- 视频弹窗 -->
                <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="70%" @close="closeVideo">
                    <video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay style="width: 100%;"></video>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {getIndex} from "@/api/index.js"
    export default {
        name: "banner",
        props: {
            banner:Array
        },
        data() {
            return {
                bannerHeight: "26vw", // 轮播高度自定义
                autoPlay: true,
                videoDialogVisible: false,
                currentVideoUrl: "",
                carouselH: 0,
                      // 设计稿宽高比，例如1920 * 420，比例=420/1920
                      ratio: 500 / 1923
            };
        },
        created() {
        },
        mounted() {
            this.setHeight()
            window.addEventListener('resize', this.setHeight)
          },
          beforeDestroy() {
            window.removeEventListener('resize', this.setHeight)
          },
        methods: {
            setHeight() {
                  // 获取父容器宽度，也可以 document.body.clientWidth
                  const w = '100'
                  this.carouselH = w * this.ratio
                },
            goLink(url) {
                if (url.startsWith("http")) {
                    window.open(url, "_blank");
                } else {
                    this.$router.push(url);
                }
            },
            openVideoDialog(url) {
                this.currentVideoUrl = url;
                this.videoDialogVisible = true;
                this.autoPlay = false;
            },
            closeVideo() {
                this.currentVideoUrl = "";
                this.videoDialogVisible = false;
                this.autoPlay = true;
            }
        }
    };
</script>
<style scoped>
    /deep/ .banner-img {
      width:100%;
      height:100%;
      object-fit: cover;
      object-position: center;
      display:block;
    }
    /* 深度修改轮播左右箭头背景 */
    /deep/ .el-carousel__arrow {
      background-color: rgba(0, 0, 0, 0.6); /* 加深黑色半透明背景 */
      width: 44px;
      height: 44px;
    }
    /* hover 更深一点 */
    /deep/ .el-carousel__arrow:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }
    /* 箭头图标白色加粗 */
    /deep/ .el-carousel__arrow i {
      font-size: 20px;
      color: #fff;
    }
    .el-carousel{
        height: 500px;
    }
    .banner-box {
        width: 100%;
    }
    .banner-item {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;
    }
    /deep/ .banner-item img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    /* 视频播放遮罩 */
    .play-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 60px;
        color: #fff;
    }
</style>